import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CustomerBankAccountSetupComponent } from './components/customerRegistration/customer-bank-account-setup/customer-bank-account-setup.component';
import { CustomerPersonalizedEmailNotificationComponent } from './components/customerRegistration/customer-personalized-email-notification/customer-personalized-email-notification.component';
import { CustomerProductServiceSetupComponent } from './components/customerRegistration/customer-product-service-setup/customer-product-service-setup.component';
import { CustomerProfileSetupComponent } from './components/customerRegistration/customer-profile-setup/customer-profile-setup.component';
import { CustomerTaxAccountSetupComponent } from './components/customerRegistration/customer-tax-account-setup/customer-tax-account-setup.component';
import { LoanlogicsPricingServiceFeeSetupComponent } from './components/customerRegistration/loanlogics-pricing-service-fee-setup/loanlogics-pricing-service-fee-setup.component';
import { DailyReportsComponent } from './components/dailyWeeklyReports/daily-reports/daily-reports.component';
import { DashboardComponent } from './components/loginComponents/dashboard/dashboard.component';
import { ForgetPasswordComponent } from './components/loginComponents/forget-password/forget-password.component';
import { LoginComponent } from './components/loginComponents/login/login.component';
import { RegistrationComponent } from './components/loginComponents/registration/registration.component';
import { ResetPasswordComponent } from './components/loginComponents/reset-password/reset-password.component';
import { AddPayeeComponent } from './components/payeePaymentLinks/add-payee/add-payee.component';
import { CreateOrderComponent } from './components/payeePaymentLinks/create-order/create-order.component';
import { CreatePaymentLinkComponent } from './components/payeePaymentLinks/create-payment-link/create-payment-link.component';
import { PromotionCodeComponent } from './components/payeePaymentLinks/promotion-code/promotion-code.component';
import { RecivePaymentNotificationComponent } from './components/payeePaymentLinks/recive-payment-notification/recive-payment-notification.component';
import { SavePaymentDetailsComponent } from './components/payeePaymentLinks/save-payment-details/save-payment-details.component';
import { SetupPayeeInvoiceComponent } from './components/payeePaymentLinks/setup-payee-invoice/setup-payee-invoice.component';
import { SharePaymentLinkComponent } from './components/payeePaymentLinks/share-payment-link/share-payment-link.component';
import { TrackPaymentsComponent } from './components/payeePaymentLinks/track-payments/track-payments.component';
import { CreatePartialRefundComponent } from './components/payeeRefund/create-partial-refund/create-partial-refund.component';
import { TrackRefundComponent } from './components/payeeRefund/track-refund/track-refund.component';
import { TrackOrdersComponent } from './components/trackTransactions/track-orders/track-orders.component';
import { TrackPayoutsComponent } from './components/trackTransactions/track-payouts/track-payouts.component';
import { TrackRefundsComponent } from './components/trackTransactions/track-refunds/track-refunds.component';

//operation
import { OpspaymentsComponent } from './operations/ops-payments/opspayments.component';
import { OpsrefundComponent } from './operations/ops-refund/opsrefund.component';
import { OpsremittancesComponent } from './operations/ops-remittances/opsremittances.component';
import { OpssettlementComponent } from './operations/ops-settlement/opssettlement.component';
import { OpsdisputesComponent } from './operations/ops-disputes/opsdisputes.component';
import { OpsRemitManagerComponent } from './operations/ops-remit-manager/ops-remit-manager.component';
import { OpsCashProBatchComponent } from './operations/ops-cash-pro-batch/ops-cash-pro-batch.component';
import { OpsSheetComponent } from './operations/ops-sheet/ops-sheet.component';
import { OpsCompletionRemitComponent } from './operations/ops-completion-remit/ops-completion-remit.component';
import { OpsBkRemitComponent } from './operations/ops-bk-remit/ops-bk-remit.component';
import { OpsBkRevShareComponent } from './operations/ops-bk-rev-share/ops-bk-rev-share.component';
import { OpsRevenueShareComponent } from './operations/ops-revenue-share/ops-revenue-share.component';
import { OpsAccountingComponent } from './operations/ops-accounting/ops-accounting.component';
import { OpsNinetyDaysComponent } from './operations/ops-ninety-days/ops-ninety-days.component';
import { OpsTransactionalGridComponent } from './operations/ops-transactional-grid/ops-transactional-grid.component';
import { OpsImportComponent } from './operations/ops-import/ops-import.component';
import { OpsMonthlyAccountingComponent } from './operations/ops-monthly-accounting/ops-monthly-accounting.component';
import { OpsVendorInfoComponent } from './operations/ops-vendor-info/ops-vendor-info.component';

//new design
import { PaymentsComponent } from './Product/payments/payments.component';
import { PaymentLinkComponent } from './Product/payment-link/payment-link.component';
import { CreatePayementComponent } from './Product/create-payement/create-payement.component';
import { BankDetailsComponent } from './Product/bank-details/bank-details.component';
import { CompanyDetailsComponent } from './Product/company-details/company-details.component';
import { PublicDetailsComponent } from './Product/public-details/public-details.component';
import { ProductSettingComponent } from './Product/product-setting/product-setting.component';
import { PaymentTransactionComponent } from './Product/payment-transaction/payment-transaction.component';
import { VendorsComponent } from './Product/vendors/vendors.component';
import { MyProfileComponent } from './Product/my-profile/my-profile.component';
import { EditVendorComponent } from './Product/edit-vendor/edit-vendor.component';
import { AddNewVendorComponent } from './Product/add-new-vendor/add-new-vendor.component';
import { RegisterComponent } from './Product/register/register.component';
import { SignInComponent } from './Product/sign-in/sign-in.component';
import { RefundComponent } from './Product/refund/refund.component';
import { TransactionDetailPageComponent } from './Product/transaction-detail-page/transaction-detail-page.component';
import { PaymentLinkInformationComponent } from './Product/payment-link-information/payment-link-information.component';
import { DashboardCompComponent } from './Product/dashboard-comp/dashboard-comp.component';
import { MainDashboardComponent } from './Product/main-dashboard/main-dashboard.component';
import { InactiveUserComponent } from './Product/inactive-user/inactive-user.component';
import { InactiveAllComponent } from './Product/inactive-all/inactive-all.component';
import { AllCompoComponent } from './Product/all-compo/all-compo.component';
import { ForgotPasswordComponent } from './Product/forgot-password/forgot-password.component';
import { AuthGuard } from './_services/auth.guard';
import { UpdateBankComponent } from './Product/update-bank/update-bank.component';
import { UpdateCompanyComponent } from './Product/update-company/update-company.component';
import { SuccessPopUpComponent } from './Product/popup/success-pop-up/success-pop-up.component';
import { ExpirePopUpComponent } from './Product/popup/expire-pop-up/expire-pop-up.component';
import { SessionTimeOutComponent } from './Product/popup/session-time-out/session-time-out.component';
import { ProcessedComponent } from './Product/popup/processed/processed.component';
import { ForgotPassComponent } from './Product/forgot-pass/forgot-pass.component';
import { ResetPassComponent } from './Product/reset-pass/reset-pass.component';
import { ErrorPopUpComponent } from './Product/popup/error-pop-up/error-pop-up.component';
import { CancelPayPopupComponent } from './Product/popup/cancel-pay-popup/cancel-pay-popup.component';
import { CancelPaymentSuccessComponent } from './Product/cancel-payment/cancel-payment-success/cancel-payment-success.component';
import { MainDashComponent } from './Product/main-dash/main-dash.component';
import { Router, Scroll } from '@angular/router';
import { EmailComponent } from './Product/email/email.component';
import { MaxAttemptPopUpComponent } from './Product/popup/max-attempt-pop-up/max-attempt-pop-up.component';
import { VendorAllCompComponent } from './Product/vendorScreen/vendor-all-comp/vendor-all-comp.component';
import { VendorProfileComponent } from './Product/vendorScreen/vendor-profile/vendor-profile.component';
import { VendorChangePassworsComponent } from './Product/vendorScreen/vendor-change-passwors/vendor-change-passwors.component';
import { VendorPublicDetailsComponent } from './Product/vendorScreen/vendor-public-details/vendor-public-details.component';
import { VendorPayTransComponent } from './Product/vendorScreen/vendor-pay-trans/vendor-pay-trans.component';
import { VendorDashboardComponent } from './Product/vendorScreen/vendor-dashboard/vendor-dashboard.component';
import { VendorRefundComponent } from './Product/vendorScreen/vendor-refund/vendor-refund.component';
import { VendorTransDetailsComponent } from './Product/vendorScreen/vendor-trans-details/vendor-trans-details.component';

const appRoutes: Routes = [

  { path: '', redirectTo: 'mainDashboard', pathMatch: 'full' },
  { path: 'email', component: EmailComponent },
  { path: 'signin', component: SignInComponent },
  { path: 'mainDashboard', component: MainDashComponent },
  { path: 'mainDash', component: MainDashboardComponent },
  { path: 'registration', component: RegisterComponent },
  { path: 'success', component: SuccessPopUpComponent },
  { path: 'expired', component: ExpirePopUpComponent },
  { path: 'cancelled', component: CancelPayPopupComponent },
  { path: 'maxAttempts', component: MaxAttemptPopUpComponent },
  { path: 'paymentlinks', component: PaymentLinkComponent },
  { path: 'paymentlink/:paymentLink', component: PaymentLinkComponent },
  { path: 'processed', component: ProcessedComponent },
  { path: 'forgotPassword', component: ForgotPassComponent },
  { path: 'resetPassword', component: ResetPassComponent },
  { path: 'sessionTimeout', component: SessionTimeOutComponent },
  { path: 'error', component: ErrorPopUpComponent },
  {
    path: 'paymentLinkInfo/:paymentRequestId',
    component: PaymentLinkInformationComponent
  },
  {
    path: 'All', component: AllCompoComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: MainDashboardComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
      },
      {
        path: 'dashboardCompo',
        component: DashboardCompComponent,
        canActivateChild: [AuthGuard]
      },
      {
        path: 'payment',
        component: PaymentsComponent
      },
      {
        path: 'createpayment',
        component: CreatePayementComponent
      },
      {
        path: 'bankdetails',
        component: BankDetailsComponent
      },
      {
        path: 'updateBank',
        component: UpdateBankComponent
      },
      {
        path: 'companydetails',
        component: CompanyDetailsComponent
      },
      {
        path: 'updateCompany',
        component: UpdateCompanyComponent
      },
      {
        path: 'publicDetails',
        component: PublicDetailsComponent
      },
      {
        path: 'productSetting',
        component: ProductSettingComponent
      },
      {
        path: 'paymentTransaction',
        component: PaymentTransactionComponent
      },
      {
        path: 'vendors',
        component: VendorsComponent
      },
      {
        path: 'myProfile',
        component: MyProfileComponent
      },
      {
        path: 'editVendor/:vendorRegistrationId',
        component: EditVendorComponent
      },
      {
        path: 'addnewvendior',
        component: AddNewVendorComponent
      },
      {
        path: 'refunds',
        component: RefundComponent
      },
      {
        path: 'transactionDetails/:paymentRequestId',
        component: TransactionDetailPageComponent,
      },

      {
        path: 'changePassword',
        component: ForgotPasswordComponent
      },

    ]
  },

  //inactive user
  {
    path: "inactiveAll", component: InactiveAllComponent,
    //canActivate:[AuthGuard],
    children:
      [
        { path: 'inactiveUser', component: InactiveUserComponent },
        { path: 'bankdetails', component: BankDetailsComponent },
        { path: 'companydetails', component: CompanyDetailsComponent },
        { path: 'publicDetails', component: PublicDetailsComponent },
        { path: 'productSetting', component: ProductSettingComponent },
        { path: 'myProfile', component: MyProfileComponent },
      ]
  },

  //vendor
  {
    path: 'AllVendor', component: VendorAllCompComponent,
    // canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: MainDashboardComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
      },
      {
        path: 'vendorProfile',
        component: VendorProfileComponent,
      },
      {
        path: 'vendorChangePass',
        component: VendorChangePassworsComponent,
      },
      {
        path: 'vendorPublicDetails',
        component: VendorPublicDetailsComponent,
      },
      {
        path: 'vendorPaymentTrans',
        component: VendorPayTransComponent,
      },
      {
        path: 'vendorDashboard',
        component: VendorDashboardComponent,
      },
      {
        path: 'vendorRefund',
        component: VendorRefundComponent,
      },
      {
        path: 'vendorTransDetail',
        component: VendorTransDetailsComponent,
      },
    ]
  }
];

const appRoute: Routes = [

]

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        scrollPositionRestoration: 'enabled',
        // enableTracing: false,
        useHash: true
      },
    )
  ],
  exports: [
    RouterModule
  ]

})

export class AppRoutingModule { }